<template>
  <div class="upload-box">
    <el-upload
      action=""
      :show-file-list="false"
      :before-upload="handleBeforeUpload"
      :disabled="btnLoading"
    >
      <el-button size="small" plain :loading="btnLoading" icon="el-icon-upload">
        选择文件
      </el-button>
    </el-upload>
    <el-link
      v-if="file && file.name"
      class="ellipsis"
      :underline="false"
      @click="handlePreview(file.path)"
      >{{ file.name }}</el-link
    >
  </div>
</template>

<script>
import qiniuService from "@/global/service/qiniu";

export default {
  props: {
    space: {
      type: String,
      default: ""
    },
    folder: {
      type: String,
      default: "service_admin"
    },
    api: {
      type: String,
      default: ""
    },
    file: {
      type: Object,
      default: () => {}
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    needCallback: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      btnLoading: false,
      upload_file: {
        file_url: "",
        file_name: "",
        file_id: ""
      }
    };
  },
  methods: {
    handleBeforeUpload(file) {
      if (!file || this.btnLoading) {
        return false;
      }
      const space = this.space;
      const folder = this.folder;
      const api = this.api;

      this.btnLoading = true;
      qiniuService
        .upload({ space, folder, file, api }, () => {})
        .then(res => {
          const upload_file = {
            path: res.url,
            id: res.id,
            name: res.name
          };
          this.upload_file = upload_file;
          this.$emit("update:file", upload_file);
          this.$message.success("上传成功");
          if (this.needCallback) {
            this.$emit("cb", res.id);
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
      return false;
    },
    handlePreview(url) {
      if (url) {
        window.open(url);
      }
    },
    copyUrl() {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", this.url);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$message.success("复制成功！");
      }
      document.body.removeChild(input);
    },
    validateSize(file) {
      const size = this.uploadLimit * 1024;
      const fileName = file.name;
      const suffix = fileName.split(".").pop();
      const imageRegex = /(zip|rar)/;
      if (file.size > size || !imageRegex.test(suffix)) {
        if (this.uploadLimit < 1024) {
          this.$message.error(
            `请上传不大于 ${this.uploadLimit}KB 且格式为zip、rar 的文件`
          );
        } else {
          this.$message.error(
            `请上传不大于 ${this.uploadLimit / 1024}MB 且格式为zip、rar 的文件`
          );
        }
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="less" scope>
.upload-box {
  .link-box {
    margin-left: 20px;
    .link-item {
      flex: none;
      display: block;
      .el-link--inner {
        font-size: 14px !important;
        line-height: 30px;
      }
    }
  }
}
</style>
